<template>

  <div class="container">
    <h3 class="main-title">Contrato</h3>
    <Preloader v-if="!contractStatus"></Preloader>
    <form novalidate v-else>
      <transition name="fade">
        <div class="row row-responsive">
          <div class="column column-xs-100">
            <div class="box-contract" v-html="contractHTML"></div>
            <div class="box-sign" v-if="rawHTML !== ''">
              <label class="input checkbox float-left">Leí y acepto este contrato
                <input type="checkbox" v-model="contractSign" />
                <div class="indicator"></div>
              </label>
              <button class="button float-right" :disabled="contractSign === false" @click.prevent="signContract()">Firmar contrato</button>
            </div>
          </div>
        </div>
      </transition>
    </form>
  </div>

</template>

<script>

import Preloader from '@/components/Preloader'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'StepContract',
  data () {
    return {
      rawHTML: '',
      contractSigned: false,
      contractSign: true,
      contractStatus: false
    }
  },
  computed: {
    contractHTML: function () {
      const parsedstr = new DOMParser().parseFromString(
        this.rawHTML, 'text/html')
      return parsedstr.documentElement.textContent
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  components: {
    Preloader
  },
  methods: {
    getContractPreview: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/contract-preview/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
            if (response.data.html) {
              this.contractStatus = true
              this.rawHTML = response.data.html
              this.doScroll(190)
            } else if (response.data.message) {
              this.rawHTML = ''
              this.contractSigned = true
              this.nextStep()
            }
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    },
    signContract: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/contracts/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.doScroll()
            this.rawHTML = ''
            this.contractSigned = true
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    }
  },
  created: function () {
    setTimeout(() => {
      this.getContractPreview()
    }, 2000)
  }
}

</script>

<style lang="scss" scoped>

.box-contract {
  margin-bottom: 2rem;
  max-height: 500px;
  overflow: auto;
  border: 1px solid #ccc;
  background-color: $white;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepContract.vue